export const APP_ROUTES = {
	HOME:  '/',
	ABOUT: {
		ABOUT_WT:         '/about-wastic',
		STORES_LIST:      '/stores',
		STORE_DETAIL:     '/stores/:slug',
		SUSTAINABLE_MOVE: '/sustainable-move',
		WT_FOLK:          '/wastic-folks',
	},
	ACCOUNT: {
		ORDERS:       '/account/orders',
		ORDER_DETAIL: '/account/orders/:orderId',
		ADDRESSES:    '/account/addresses',
		PROFILE:      '/account',
	},
	AUTH: {
		AUTH:            '/auth',
		FORGOT_PASSWORD: '/forgot-password',
		LOGIN:           '/login',
		REGISTER:        '/register',
		RESET_PASSWORD:  '/reset-password',
		CHANGE_PASSWORD: '/change-password',
	},
	CUSTOMER_CARE: {
		CONTACT_US: '/contact-us',
		FAQ:        '/faq',
	},
	LEGAL: {
		SHIPPING_POLICY:  '/shipping-policy',
		PRIVACY_POLICY:   '/privacy-policy',
		TERMS_OF_SERVICE: '/terms-of-service',
	},
	PAYMENT: {
		CART:     '/cart',
		CHECKOUT: '/checkout',
	},
	SHOP: {
		COLLECTION_LIST: '/our-collections',
		COLLECTION:      '/our-collections/:collectionSlug',
		PRODUCT_DETAILS: '/our-collections/:collectionSlug/:productSlug',
		SPECIAL_PRICE:   '/special-price',
	},
	CONFIRM_PURCHASE: '/confirm-purchase',
	QR_PAYMENT:       '/qr-payment/:orderId',
	PAYPAL_PAYMENT:	  '/payment/:orderId',
} as const;
